import { Button, Card } from "components/atoms";
import ListWrapper from "components/molecules/list-wrapper/ListWrapper";

import Popup from "components/molecules/popup";
import i18next from "i18next";

import { useGetLabel } from "services/labels";
import { useIsUserBanned } from "hooks/useIsUserBanned";
import { TopBar } from "components/organisms";
import { TopbarPage } from "components/templates";
import { PiPlus } from "react-icons/pi";
import { PopupActions } from "reactjs-popup/dist/types";
import { usePostResidanceCertificate } from "services/labels/residanceCertificate";
import { ILabelResidenceCertificateMutation } from "services/labels/types";
import { BUTTON_VARIANT } from "types/components/button/button.interface";
import { formatDate } from "utils/global/date.utils";

const Certificates = () => {
  const { data: label, isLoading, refetch } = useGetLabel(false);

  const addResidanceCertificate = usePostResidanceCertificate(label?.id ?? "");

  const onAddResidanceCertificate = async (
    certificate: ILabelResidenceCertificateMutation,
    actions: PopupActions,
  ) => {
    await addResidanceCertificate.mutateAsync(certificate, {
      onSuccess: async () => {
        await refetch();
        actions.close();
      },
    });
  };
  const { isBanned } = useIsUserBanned();
  return (
    <TopbarPage
      topbarAbsolute
      topbar={
        <TopBar
          title={i18next.t("navbar.certificates")}
          path=""
          customBackItem={<div />}
          topbarContent={
            <div className="w-full flex justify-end">
              {!isBanned && (
                <Popup.LabelResidanceCertificate
                  trigger={
                    <Button variant={BUTTON_VARIANT.submit} onlyIcon>
                      <Button.Icon icon={<PiPlus />} />
                    </Button>
                  }
                  onAdd={onAddResidanceCertificate}
                />
              )}
            </div>
          }
        >
          {" "}
        </TopBar>
      }
    >
      <ListWrapper
        isLoading={isLoading}
        items={label?.residenceCertificates}
        item={(certificate, index) => (
          <Card
            key={index}
            header={`${
              i18next.language === "pl"
                ? certificate.country.polishName
                : certificate.country.englishName
            } `}
            // header={`${
            //   i18next.language === 'pl'
            //     ? certificate.country.polishName
            //     : certificate.country.englishName
            // }
            // ${certificate.countryVatTax?.vatTax !== undefined ? `(${certificate.countryVatTax?.vatTax}%)` : ''}`}
            description={formatDate(certificate.expirationDate)}
          />
        )}
      />
    </TopbarPage>
  );
};

export default Certificates;
